import { Controller, useFormContext } from "react-hook-form";
import { type InputProps } from "antd";
import { ErrorMessage } from "@hookform/error-message";
import classNames from "classnames";
import { AppInput } from "@/shared/Components/Inputs";
import type { FC } from "react";
import { InputError } from "../../InputError";
import { handleErrors } from "../../helpers";
import styles from "./styles.module.scss";

export const FormInput: FC<InputProps & { customOnChange?: () => void }> = ({
  name = "",
  customOnChange,
  ...props
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ref } }) => (
        <AppInput
          ref={ref}
          value={value}
          status={errors[name] ? "error" : ""}
          suffix={
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => {
                return <InputError message={message} />;
              }}
            />
          }
          className={classNames({
            [styles["input-error"]]: handleErrors(errors, name),
          })}
          onChange={(e) => {
            onChange(e);
            customOnChange?.();
          }}
          {...props}
        />
      )}
    />
  );
};
